module.exports = __webpack_public_path__ + "img/DE.d956f47d.webp";